export default __webpack_public_path__ + "static/media/bronze.2deacfdd.png";